<template>
    <div class="message-list-item-container" @click="onClick" :class="{ 'message-old-message' : !newMessage , 'message-list-item-this-action': action}">
        <div class="message-list-item-main-container">
            <div class="message-list-item-send-info-container">
                <div class="message-list-item-icon message-send-system" :class="{ 'message-list-item-icon-read': !newMessage }">
                    <d2-icon name="envelope-o"></d2-icon>
                </div>
                <div class="message-list-item-send-container common-flex-center-between">
                    <div class="message-list-item-send-user common-ellipsis">
                        {{sendUser}}
                    </div>
                    <div class="message-list-item-send-date">{{dateConvert(sendDate)}}</div>
                </div>
            </div>
            <div class="common-ellipsis message-list-item-title-container" :class="{'message-new-message-title': newMessage}">
                {{title}}
            </div>
            <div class="common-ellipsis message-list-item-content-container" v-if="false">
                {{content}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MessageListItem",
        props: {
            avatar: {
                type: String,
                default: ''
            },
            sendUser: {
                type: String,
                default: ''
            },
            sendDate: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            content: {
                type: String,
                default: ''
            },
            newMessage: {
                type: Boolean,
                default: false
            },
            index: {
                type: Number,
                required: true
            },
            currentIndex: {
                type: Number,
                default: 0
            }
        },
        methods: {
            onClick (){
                this.$emit('mail-change', this.index, this.item)
            },
            dateConvert (date) {
                let dateMoment
                try {
                    dateMoment = this.moment(date)
                }catch (e) {
                    return '无效'
                }
                dateMoment = Number(dateMoment.format('YYYYMMDD'))
                let now = this.moment()
                let startDate = Number(now.format("YYYYMMDD"))
                if (startDate === dateMoment){
                    return '今天'
                }else if (dateMoment === startDate - 1){
                    return '昨天'
                }else if (dateMoment === startDate - 2){
                    return '前天'
                }else{
                    return this.moment(date).format("YYYY-MM-DD")
                }
            }
        },
        computed: {
            action() {
                return this.index === this.currentIndex
            }
        }
    }
</script>

<style scoped lang="scss">
.message-list-item-container {
    background: #FFFFFF;
    width: 100%;
    height: 76px;
    position: relative;
    box-sizing: border-box;
    border-left: 5px solid #C5C5C5;
    transition: border-left-color .7s;
    padding: 5px 5px 0 0;
    &  * {
        box-sizing: border-box;
        cursor: default;
    }

    .message-list-item-main-container {
        padding-left: 8px;
        border-bottom: 1px solid #E3E8EA;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .message-list-item-send-info-container{
            width: 100%;
            height: 32px;
            margin-top: 4px;
            display: flex;
            overflow: hidden;
            .message-list-item-icon{
                border-radius: 50%;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                width: 32px;
                height: 32px;
                & > i{
                    margin: 0 auto;
                    font-weight: 400;
                    font-size: 18px;
                    color: #ffffff;
                }
            }
            .message-list-item-send-container {
                flex: 1;
                overflow: hidden;
                margin-left: 18px;
                align-items: center;
                .message-list-item-send-user{
                    color: #4E4E4E;
                    font-size: 16px;
                    height: 1.3em;
                    max-width: 8em;
                }
                .message-list-item-send-date{
                    color: #AFAFAF;
                    font-size: 15px;
                    height: 1.3em;
                }
            }
            .message-list-item-title-container {
                display: block;
                width: 100%;
                color: #3B3C3F;
                font-size: 17px;
                padding: 0;
                height: 1.2em;
            }
        }
        .message-list-item-title-container {
            display: block;
            width: 100%;
            color: #3B3C3F;
            font-size: 17px;
            padding: 0;
            height: 1.2em;
            margin-top: 8px;
        }
        .message-list-item-content-container {
            display: block;
            width: 100%;
            color: #B3B5BF;
            font-size: 15px;
            height: 1.2em;
            margin-top: 5px;
        }
    }

}
.message-list-item-container:hover{
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
    z-index: 19951217;
}
.message-old-message{
    background: #F5F7F7;
}
.message-new-message-title{
    color: #388BFF !important;
}
.message-send-system{
    background: #2f74ff;
}
.message-list-item-this-action {
    padding-left: 0;
    border-left: 5px solid #389AFF;
    transition: border-left-color .7s;
}
.message-list-item-icon-read{
    background-color: #808080;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/Messages/components/MessageListItem.vue"
}
</vue-filename-injector>
